


































































































import { Component, Vue } from 'vue-property-decorator'
import DefaultButton from './ui/DefaultButton.vue'
import NavigationButtons from './ui/NavigationButtons.vue'
import ProfileStep from './ProfileStep.vue'

@Component({
  components: {
    DefaultButton,
    NavigationButtons,
    ProfileStep
  }
})
export default class ProfileAdvice extends Vue {
  private get adviceMultifocal (): boolean {
    return this.$store.getters['matrix/adviceMultifocal']
  }

  private get adviceScreenGlasses (): boolean {
    return this.$store.getters['matrix/adviceScreenGlasses']
  }

  private get adviceSportGlasses (): boolean {
    return this.$store.getters['matrix/adviceSportGlasses']
  }

  private get adviceSunGlasses (): boolean {
    return this.$store.getters['matrix/adviceSunGlasses']
  }
}
